import React, { useState, useEffect, useMemo, } from "react";
import { compose, withStateHandlers, withState } from "recompose";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  Page,
  FormGroup,
  PendingButton,
} from "components/common";
import {
  Input,
  ModalFooter,
  Modal,
  ModalBody,
  ModalHeader,
  UncontrolledButtonDropdown,
  Table, ButtonDropdown, Dropdown, DropdownItem, DropdownToggle, DropdownMenu,
  UncontrolledDropdown,
} from 'reactstrap';
import { Control, LocalForm } from "react-redux-form";
import { NotificationManager } from "react-notifications";
import { useOrganisationContext, usePopover } from "hooks";
import Select from "react-select";
import { Nav, NavItem, NavLink, TabContent, TabPane, Row, Col, Card, CardFooter, CardTitle, CardText, CardBody, Container, Button } from 'reactstrap';
import BackButton from "components/refactoring/BackButton";
import { ApiClient } from "services";
import { getOutlineStyle } from "pages/UserList/Edit";
import { customDateFormat, languageNameMapping } from "services/util"
import { ColouredLink } from "components/HoverCard";
import CustomLoader from "components/common/CustomLoader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import download from "downloadjs";
import countryList from 'react-select-country-list';
import UpdateBillingContactForm, { hasBillingAddressData } from 'components/BillingContact/UpdateBillingContactForm';

const colStyle = {
  xs: false,
  md: 12,
  className: "pt-1 pb-1"
}

const cardStyle = {
  className: "mb-4 border px-4 py-4 mt-2",
  role: "alert",
  //style: {backgroundColor: "rgba(0, 0, 0, 0.03)", color: "rgba(0, 0, 0, 0.8)"}
  style: {backgroundColor: "#f6f9fc", color: "#32325d"}
}

const smallHeader = {
  style: {fontSize: "1.3em"}
}

const styleCheck = {
  style:{fontSize: "1rem"},
  className:"ml-2"
}

const checkboxStyle = {
  style: { position: 'relative', marginTop: 0, marginInlineStart: 0, }
}

const renderBillingAddress = (i) => (
  <div className="pl-1">
    <CardText>
      <Trans>Full Name:</Trans> {i.first_name}
    </CardText>
    <CardText>
      <Trans>Email:</Trans> {i.email}
    </CardText>
    <CardText>
      <Trans>Contact Number:</Trans> {i.contact_number}
    </CardText>
    <CardText>
      <Trans>Address:</Trans> {i.address_first_line}, {i.city}, {i.region}, {i.country}, {i.postal_code}
    </CardText>
  </div>
);

const renderAddons = (list, name) => (
  <>
  <p {...smallHeader}><strong><Trans>{name}:</Trans></strong></p>
  {list?.map((i, idx) => ( 
    <div key={idx} className="pl-1" style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: '0.3em', fontSize:"1.5em" }}>&#8226;</span>
      <CardText>{i.content_object_data?.category ? <>{i.content_object_data.category} - </> : <></>}{i.content_object_data.name}</CardText>
    </div>
  ))}
  </>
);

export const Details = ({ client, history, t, }) => {

  const countryOptions = useMemo(() => countryList().getData(), [])

  const { selectedOrganisation } = useOrganisationContext()

  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState();
  const [subscription, setSubscription] = useState()
  const [billingData, setBilling] = useState()
  
  // Confirmation modal states
  const [showPayModal, setShowPayModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [selectedOption, setSelectedOption] = useState('')
  const [invoiceList, setInvoiceList] = useState([])

  const [toggle, setToggle] = useState(false)

  const [showUpdateBillingModal, setShowUpdateBillingModal] = useState(false);
  const [selectedBillingAddress, setSelectedBillingAddress] = useState(null);
  const [addNewContact, setAddNewContact] = useState(false);
  const [billingAddressId, setBillingAddressId] = useState(null);

  // Add this function to handle billing address updates
  const handleUpdateBillingAddress = async (values) => { 
    
    const billingValidation = hasBillingAddressData(values?.billing_address_data);
    if (!billingValidation.isValid) {
      NotificationManager.error(billingValidation.error || t("Please fill all required fields"));
      return;
    }

    setIsSending(true);
    
    try {
      const endpoint = `/connected_organisations/${selectedOrganisation.id}/update-billing-address`;
      const response = await client.put(endpoint, {...values, billing_address: selectedBillingAddress.id});
      
      NotificationManager.success(t("Billing address updated successfully"));
      setShowUpdateBillingModal(false);
      fetchData(); // Refresh the billing data
    } catch (error) {
      console.error("Error updating billing address:", error);
      if (error.response?.data) {
        Object.entries(error.response.data).forEach(([key, value]) => {
          const fieldName = snakeToTitle(key);
          NotificationManager.error(`${fieldName} - ${value}`);
        });
      } else {
        NotificationManager.error(t("An error occurred while updating"));
      }
    } finally {
      setIsSending(false);
    }
  };
  
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedOption('')
    setShowPayModal(false);
    setShowCancelModal(false);
    setSelectedInvoiceId(null);
  };

  const handlTableClose = () => {
    setShowTable(false);
  };

  const fetchData = async () => {
    try {
      setLoading(true)
      const res = await client.get(`connected_organisations/${selectedOrganisation.id}/subscription`);
      const billing = await client.get(`/connected_organisations/${selectedOrganisation.id}/billing-address`);
      
      const data = res.data;
      setSubscription(data);
      setBilling(billing.data)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
    }
  } 

  const fetchInvoices = async () => {
    try {
      setLoading(true)
      const invoiceResponse = await client.get(`/connected_organisations/${selectedOrganisation.id}/subscription-invoices`);
      setInvoiceList(invoiceResponse?.data?.subscription_invoices)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
    fetchInvoices()
  }, [selectedOrganisation])

  const goToChangeSubscriptionPage = (subscription, action = null) => {
    if (action === "renew") {
      let params = {
        pathname: `/subscription-summary/${subscription?.current_plan?.subscription_plan_id}`,
        search: `action=renew`
      }
      history.push(params)
    } else {
      history.push('/change-subscription')
    }
  }

  const showRenewButton = (subscription) => {
    return subscription?.current_plan?.is_renewable
  }

  const downloadInvoice = (invoiceId, lang = 'en') => {
    client.get(`/subscription-invoices/${invoiceId}/download`, { 
      params: { lang },
    }).then(res => {
      download(res.data?.content, res.data?.filename)
    })
  }

  const onClickHandler = (invoiceId, action, lang = 'en') => { 
    if (action === 'pay') {
      setSelectedInvoiceId(invoiceId);
      setShowPayModal(true);
    } else if (action === 'cancel') {
      setSelectedInvoiceId(invoiceId);
      setShowCancelModal(true);
    } else if (action === 'download') {
      downloadInvoice(invoiceId, lang)
    }
  }

  // Confirmation handlers
  const handleConfirmPay = () => {
    setShowPayModal(false);
    payInvoice(selectedInvoiceId);
    setSelectedInvoiceId(null);
  }

  const handleConfirmCancel = () => {
    setShowCancelModal(false);
    cancelInvoice(selectedInvoiceId);
    setSelectedInvoiceId(null);
  }

  const responseError = "No Response from the server, please try again"

  const payInvoice = (invoiceId) => { 
    setLoading(true)

    client.post(`/payment`, { invoice: invoiceId })
      .then(res => {
        setLoading(false)

        NotificationManager.success(t('Payment details sent to TAP!'))

        setTimeout(() => {
          if (res?.data.transaction_url) {
            window.location.href = res?.data.transaction_url;
          } else {
            NotificationManager.error(t(responseError))
          }
        }, 200)

      })
  }

  const cancelInvoice = async (invoiceId) => {
    setLoading(true);
    const endpoint = `/subscription-invoices/${invoiceId}/cancel`;

    client.get(endpoint)
      .then(response => {
        setLoading(false);
        NotificationManager.success(t(response?.data?.detail || "Invoice cancelled successfully."))
        fetchInvoices()
      })
  }

  const reasonType = [
    {value: "Too Expensive", label: t("Too Expensive")},
    {value: "Not Satisfied", label: t("Not Satisfied")},
    {value: "Changing Application", label: t("Changing Application")},
    {value: "Changing Plan", label: t("Changing Plan")},
    {value: "Other Reason", label: t("Other Reason")},
  ]

  function snakeToTitle(str) {
    return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  const handlePost = async (values) => {

    setIsSending(true);

    const id = subscription?.current_plan?.id || 0

    if (id === 0) {
      NotificationManager.error(t("The Subscription Cannot be cancelled, please contact the Admin"))
      return
    }

    let endpoint = `/cancel-subscription/${id}`

    client.post(endpoint, values)
      .then(response => {
          setTimeout(() => {
            setIsSending(false)
            NotificationManager.success(t(response?.data?.detail || "Successfully cancelled the subscription"));
              setTimeout(() => {
                handleModalClose()
                window.location.reload()
              }, 1000);
          }, 1000);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            NotificationManager.error(errorMessage)
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  };

  const currentPlan = subscription?.current_plan
  const languageList = currentPlan?.subscribed_feature_list?.filter(i => i.content_type_name === "hesaablanguage")
  const moduleList = currentPlan?.subscribed_feature_list?.filter(i => i.content_type_name === "hesaabmodule")
  const appList = currentPlan?.subscribed_feature_list?.filter(i => i.content_type_name === "hesaabapplication")

  const inActive = <span className="ml-2" style={getOutlineStyle('#E64848', "0.8em")}><Trans>{currentPlan?.subscription_status || 'No Subscription'}</Trans></span>

  const inActiveString = t("Inactive")

  const dropdownOptions = [
    // { label: `Transfer Subscription`, value: `transfer_subscription` },
    { label: t(`Change Subscription Email`), value: `change_subscription_email` },
    { label: t(`Add Client Code`), value: `add_client_code` },
  ]

  const handleClientCodePost = async (values) => {
    let postData = Object.assign({}, values)

    postData['id'] = selectedOrganisation?.id

    let endpoint = `/core/organisation-client-id`

    client.post(endpoint, postData)
      .then(response => {
          setTimeout(() => {
            setIsSending(false)
            NotificationManager.success(t(response?.data?.message || "Client code was created successfully."));
            
            handleModalClose()
          }, 1000);
      })
      .catch(error => {
        console.error("Error:", error);
        if (error.response && error.response.data) {
          const errors = error.response.data;
          Object.entries(errors).forEach(([key, value]) => {
            const fieldName = snakeToTitle(key);
            const errorMessage = `${fieldName} - ${value}`;
            NotificationManager.error(errorMessage)
          });
        } else {
          NotificationManager.error(t("An error occurred while saving"));
        }
        setIsSending(false);
      });
  }

  const handleChangeEmailPost = async (values) => {
    NotificationManager.error('Not implented yet.')
    // handleModalClose()
  }

  const linkClick = (create) => {
    history.push(`organisations${create}`)
  }
  
  const goToCustomizeSubscriptionPage = (from) => {
    history.push({
      pathname: '/customize-subscription',
      search: `from=${from}`
    })
  }

  const showChangeSubscriptionButtonLabel = (subscription) => {
    if (subscription?.current_plan?.subscription_status === "Active") {
      return <Trans>Upgrade Plan</Trans>
    } else if (subscription?.current_plan?.subscription_status === "Expired") {
      return <Trans>Change Plan</Trans>
    } else {
      return <Trans>Activate Subscription</Trans>
    }
  }

  let availableLangs = []

  if (selectedOrganisation?.is_trial) {
    availableLangs = Object.keys(languageNameMapping).filter(lang => lang !== 'en');
  } else {
    availableLangs = selectedOrganisation?.subscribed_features?.hesaablanguage?.filter(lang => lang !== 'en');
  }

  return (
    <Page>
      <BackButton/>
        {selectedOrganisation ? <>
        { loading && <CustomLoader /> }

            <div>
              <Nav tabs className="nav-hr cursor-pointer mb-3">
                <NavItem>
                    <NavLink className={activeTab == '1' ? 'active' : ''}>
                    <a style={{ cursor: 'pointer' }} onClick={() => setActiveTab('1')}>
                      <Trans>Subscription Plan Details</Trans>
                    </a>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab == '2' ? 'active' : ''}>
                    <a style={{ cursor: 'pointer' }} onClick={() => setActiveTab('2')}>
                    <Trans>Billing Account</Trans>
                    </a>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab == '3' ? 'active' : ''}>
                    <a style={{ cursor: 'pointer' }} onClick={() => setActiveTab('3')}>
                    <Trans>Add-Ons</Trans>
                    </a>
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={activeTab == '4' ? 'active' : ''}>
                    <a style={{ cursor: 'pointer' }} onClick={() => setActiveTab('4')}>
                    <Trans>Invoices</Trans>
                    </a>
                    </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <React.Fragment>
                          <Row>
                            
                            <Col>
                              <Card className="my-3 p-2">
                                {subscription && !loading && (
                                  <>
                                  <CardBody>
                                    <CardTitle tag="h5">
                                      <div style={{gap:10}}>
                                        <Trans>Subscription Plan Details</Trans>
                                        {subscription?.current_plan?.subscription_status === "Active" ? <span className="ml-2" style={getOutlineStyle('#72B566', "0.8em")}>
                                        <Trans>Active</Trans></span> : inActive}

                                        <div className="float-right">
                                          <ButtonDropdown toggle={() => setToggle(!toggle)}>
                                            <Dropdown isOpen={toggle} toggle={() => setToggle(!toggle)} direction={"down"}>
                                              <DropdownToggle caret className="btn btn-success" style={{ boxShadow: "none" }}>Options</DropdownToggle>
                                              <DropdownMenu >
                                                {
                                                  dropdownOptions.map((option) => (
                                                    <DropdownItem key={option.value} onClick={(e) => {
                                                      setSelectedOption(option.value)
                                                    }}
                                                    >{option.label}</DropdownItem>
                                                  ))}
                                              </DropdownMenu>
                                            </Dropdown>
                                          </ButtonDropdown>
                                        </div>
                                      </div>

                                    </CardTitle>
                                    <Row className="my-2 w-100">
                                      <Col>
                                        <CardText><strong><Trans>Current Plan:</Trans></strong> {subscription?.current_plan?.subscription_plan_name || inActiveString}</CardText>
                                        <CardText><strong><Trans>Billing Cycle:</Trans></strong> {subscription?.current_plan?.billing_cycle || inActiveString}</CardText>
                                        <CardText><strong><Trans>Pricing:</Trans></strong> {subscription?.current_plan ? <>{subscription?.current_plan?.subscription_plan_price?.price} ({subscription?.current_plan?.subscription_plan_price?.currency})</>: inActiveString}</CardText>
                                        <CardText><strong><Trans>Next Renewal Date:</Trans></strong> {subscription?.current_plan?.next_renewal_date ? customDateFormat(subscription?.current_plan?.next_renewal_date, 'll') : inActiveString}</CardText>
                                      </Col>
                                    </Row>
                                    <Modal isOpen={selectedOption === `change_subscription_email`} toggle={handleModalClose}>
                                      <LocalForm onSubmit={values => handleChangeEmailPost(values)}>
                                        <ModalHeader><Trans>Change Subscription Email</Trans></ModalHeader>
                                        <ModalBody>
                                          <Row>
                                            <Col {...colStyle}>
                                              <FormGroup label={t("Current Email*")}>
                                                <Control.text
                                                  model=".current_email"
                                                  className="border"
                                                />
                                              </FormGroup>
                                              <FormGroup label={t("New Email*")}>
                                                <Control.text
                                                  model=".email"
                                                  className="border"
                                                />
                                              </FormGroup>
                                            </Col>
                                          </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                          <Button color="secondary" onClick={handleModalClose}>
                                            <Trans>Close</Trans>
                                          </Button>
                                          {isSending ? 
                                          <Button color="primary" disabled><Trans><span className="fa fa-spinner fa-spin" />Saving...</Trans></Button>
                                          :
                                          <Button color="primary">
                                            <Trans>Save Changes</Trans>
                                          </Button>}
                                        </ModalFooter>
                                      </LocalForm>
                                    </Modal>
                                    <Modal isOpen={selectedOption === `add_client_code`} toggle={handleModalClose}>
                                      <LocalForm onSubmit={values => handleClientCodePost(values)}>
                                        <ModalHeader><Trans>Add client code</Trans></ModalHeader>
                                        <ModalBody>
                                          <Row>
                                            <Col {...colStyle}>
                                              <FormGroup label={t("Name*")}>
                                                <Control.text
                                                  model=".name"
                                                  className="border"
                                                />
                                              </FormGroup>
                                            </Col>
                                          </Row>
                                        </ModalBody>
                                        <ModalFooter>
                                          <Button color="secondary" onClick={handleModalClose}>
                                            <Trans>Close</Trans>
                                          </Button>
                                          {isSending ? 
                                          <Button color="primary" disabled><span className="fa fa-spinner fa-spin" /><Trans>Saving</Trans>...</Button>
                                          :
                                          <Button color="primary">
                                            <Trans>Save</Trans>
                                          </Button>}
                                        </ModalFooter>
                                      </LocalForm>
                                    </Modal>
                                  </CardBody>
                                  <CardFooter className="bg-white">
                                  <Row>
                                    <Col>
                                        <div className="d-flex justify-content-end">
                                          { showRenewButton(subscription) && <Button color="primary" onClick={() => goToChangeSubscriptionPage(subscription, 'renew')}>
                                            <Trans>Renew Current Plan</Trans>
                                          </Button> }

                                          <Button color="primary" onClick={() => goToChangeSubscriptionPage(subscription)}>
                                            <Trans>{ showChangeSubscriptionButtonLabel(subscription) }</Trans>
                                          </Button>

                                          {subscription?.current_plan && subscription?.current_plan?.subscription_status === "Active" && 
                                            <Button color="danger" onClick={() => setShowModal(true)}>
                                              <Trans>Cancel Subscription</Trans>
                                            </Button>
                                          }
                                          
                                          <Modal isOpen={showModal} toggle={handleModalClose} contentLabel="Cancelling the Subscription">
                                            <LocalForm onSubmit={values => handlePost(values)}>
                                              <ModalHeader closeButton>Cancel Subscription</ModalHeader>
                                              <ModalBody>
                                                <p><Trans>We are sad to see you go, please select one of the reasons for cancelling your subscription plan.</Trans></p>
                                                {subscription?.current_plan?.id && 
                                                <Row>
                                                  <Col {...colStyle}>
                                                    <FormGroup label={t("Reason*")} addControlClass={false}>
                                                      <Control.text style={{ backgroundColor: '#F4F7FE' }}
                                                        model=".cancellation_reason"
                                                        component={Select}
                                                        options={reasonType}
                                                        clearable={false}
                                                        simpleValue
                                                        placeholder={('Select...')}
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col {...colStyle}>
                                                    <FormGroup label={t("Note*")}>
                                                      <Control.textarea
                                                        model=".cancellation_note"
                                                        className="border"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                </Row>
                                                }
                                                <p><Trans>For any kind of further queries please vist our <a href="/aaa">feedback page</a></Trans></p>
                                              </ModalBody>
                                              <ModalFooter>
                                                <Button color="secondary" onClick={handleModalClose}>
                                                  <Trans>Close</Trans>
                                                </Button>
                                                {isSending ? 
                                                <Button color="primary" disabled><Trans><span className="fa fa-spinner fa-spin" />Cancelling</Trans></Button>
                                                :
                                                <Button color="primary">
                                                  <Trans>Confirm</Trans>
                                                </Button>}
                                              </ModalFooter>
                                            </LocalForm>
                                          </Modal>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardFooter>
                                </>)}
                              </Card>

                            </Col>
                          </Row>
                        </React.Fragment>
                    </TabPane>
                    <TabPane tabId="2">
                      <React.Fragment>
                        <Row>
                          <Col>
                            <Card className="my-3 p-2">
                              {billingData && !loading && (
                                <>
                                  {billingData?.billing_addresses ?  
                                  <CardBody>
                                    <CardTitle tag="h5"><div style={{gap:10}}><Trans>Billing Data</Trans></div></CardTitle>
                                    <Row className="my-2 w-100">
                                      <Col>
                                        <div {...cardStyle}>
                                          <p {...smallHeader}><strong><Trans>Payment Details:</Trans></strong></p>
                                          { renderBillingAddress(billingData.billing_addresses[0]) }
                                        </div>
                                      </Col>
                                      <Col>
                                        <div {...cardStyle}>
                                          
                                          <div className="d-flex justify-content-between align-items-start">
                                            <p {...smallHeader}><strong><Trans>Billing Contact:</Trans></strong></p>
                                            <Button 
                                              size="sm" 
                                              color="primary" 
                                              onClick={() => {
                                                setSelectedBillingAddress(billingData.default_address);
                                                setShowUpdateBillingModal(true);
                                              }}
                                            >
                                              <Trans>Edit</Trans>
                                            </Button>
                                          </div>

                                          { renderBillingAddress(billingData.default_address) }
                                        </div>
                                        
                                        <Modal 
                                          isOpen={showUpdateBillingModal} 
                                          toggle={() => setShowUpdateBillingModal(false)}
                                          size="lg"
                                        >
                                          <LocalForm onSubmit={handleUpdateBillingAddress}>
                                            <ModalHeader>
                                              <Trans>Update Billing Address</Trans>
                                            </ModalHeader>
                                            <ModalBody>
                                              <UpdateBillingContactForm
                                                billingData={selectedBillingAddress}
                                                setBillingAddressId={setBillingAddressId}
                                                billingAddressId={billingAddressId}
                                                countryOptions={countryOptions} // You'll need to define this
                                                t={t}
                                                colStyle={colStyle}
                                                checkboxStyle={checkboxStyle}
                                                styleCheck={styleCheck}
                                                onChangeHandler={(values) => {
                                                  // Handle form changes
                                                }}
                                              />
                                            </ModalBody>
                                            <ModalFooter>
                                              <Button color="secondary" onClick={() => setShowUpdateBillingModal(false)}>
                                                <Trans>Close</Trans>
                                              </Button>
                                              {isSending ? (
                                                <Button color="primary" disabled>
                                                  <span className="fa fa-spinner fa-spin" />
                                                  <Trans>Saving...</Trans>
                                                </Button>
                                              ) : (
                                                <Button color="primary" type="submit">
                                                  <Trans>Save Changes</Trans>
                                                </Button>
                                              )}
                                            </ModalFooter>
                                          </LocalForm>
                                        </Modal>
                                      </Col>
                                    </Row>
                                  </CardBody>: <div className="text-center" style={{gap:10}}><CardBody><CardTitle tag="h5"><Trans>No Billing Addresses Found</Trans></CardTitle></CardBody></div>}
                                </>)}
                                {billingData?.billing_addresses && 
                                <div className="d-flex justify-content-end my-2">
                                  <span><Trans>Looking for more <ColouredLink onClick={() => setShowTable(true)}>billing addresses</ColouredLink> ?</Trans></span>
                                  <Modal isOpen={showTable} toggle={handlTableClose} contentLabel="All the Billings">
                                    <ModalHeader closeButton>List of Billings</ModalHeader>
                                    <ModalBody>
                                      <Table className="border">
                                        <thead>
                                          <tr>
                                            <th><Trans>ID</Trans></th>
                                            <th><Trans>Name</Trans></th>
                                            <th><Trans>Email</Trans></th>
                                            <th><Trans>Phone</Trans></th>
                                            <th><Trans>Address</Trans></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {billingData?.billing_addresses.map((i) => (
                                          <tr key={i.id}>
                                            <td>{i.id}</td>
                                            <td>{i.first_name} {i.last_name}</td>
                                            <td>{i.email}</td>
                                            <td>{i.contact_number}</td>
                                            <td>{i.address_first_line}, {i.country}</td>
                                          </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    </ModalBody>
                                    <ModalFooter>
                                      <Button color="secondary" onClick={handlTableClose}>
                                        <Trans>Close</Trans>
                                      </Button>
                                    </ModalFooter>
                                  </Modal>
                                </div>
                              }
                            </Card>
                          </Col>
                        </Row>
                      </React.Fragment>
                  </TabPane>
                  <TabPane tabId="3">
                      <React.Fragment>
                        <Row>
                          <Col>
                            <Card className="my-3 p-2">
                              {currentPlan?.subscribed_feature_list?.length > 0 ?  
                                <CardBody>
                                  <CardTitle tag="h5"><div style={{gap:10}}><Trans>Addons Purchased:</Trans></div></CardTitle>
                                  <Row className="my-2 w-100">
                                    {languageList && <Col>
                                      <div {...cardStyle}>
                                        <div className="text-right">
                                          <Button size="sm" color="primary" onClick={() => goToCustomizeSubscriptionPage('lang')}><Trans>Buy More</Trans></Button>
                                        </div>
                                        {renderAddons(languageList, "Languages")}
                                      </div>
                                    </Col>}
                                    {moduleList && <Col>
                                      <div {...cardStyle}>
                                        {renderAddons(moduleList, "Modules")}
                                      </div>
                                    </Col>}
                                    {appList && <Col>
                                      <div {...cardStyle}>
                                        <div className="text-right">
                                          <Button size="sm" color="primary" onClick={() => goToCustomizeSubscriptionPage('app')}><Trans>Buy More</Trans></Button>
                                        </div>
                                        {renderAddons(appList, "Applications")}
                                      </div>
                                    </Col>}
                                  </Row>
                                </CardBody>: <div className="text-center" style={{gap:10}}><CardBody><CardTitle tag="h5"><Trans>No Add-Ons Found</Trans></CardTitle></CardBody></div>}
                            </Card>
                          </Col>
                        </Row>
                      </React.Fragment>
                  </TabPane>
                  <TabPane tabId="4" className="inv-table">
                      <React.Fragment>
                        <Row>
                          <Col>
                            <Card className="my-3 p-2">
                            {invoiceList?.length > 0 ?  
                                <CardBody>
                                  <Table className="border">
                                    <thead>
                                      <tr>
                                        <th>{ t('Number') }</th>
                                        <th>{ t('Issue Date') }</th>
                                        <th>{ t('Due Date') }</th>
                                        <th>{ t('Status') }</th>
                                        <th className="text-right">{ ('Amount') }</th>
                                        <th>{ t('Action') }</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {invoiceList.map((i) => 
                                      <tr key={i.id}>
                                        <td><Link to={`/subscription/invoice/${i.id}`}>{i.invoice_number}</Link></td>
                                        <td>{i.issue_date}</td>
                                        <td>{i.due_date}</td>
                                        <td>{i.status}</td>
                                        <td className="text-right"><strong>{i.currency}</strong> {i.total_amount}</td>
                                        <td width={250}>
                                          <div className="d-flex justify-content-center">
                                            <Link className="btn btn-sm btn-secondary mr-2 text-white" to={`/subscription/invoice/${i.id}`}>{ t('View') }</Link>
                                            
                                            {
                                              i.status === 'Unpaid' && <Button color="primary" size="sm" disabled={isSending} onClick={ () => onClickHandler(i.id, 'pay') }>
                                                <Trans>{ t('Pay') }</Trans>
                                              </Button>
                                            }

                                            {
                                              i.status === 'Unpaid' && <Button color="danger" size="sm" disabled={isSending} onClick={() => onClickHandler(i.id, 'cancel')}>
                                                <Trans>{ t('Cancel') }</Trans>
                                              </Button>
                                            }
                                            
                                            <UncontrolledDropdown>
                                                <DropdownToggle
                                                  caret
                                                  color={"primary"}
                                                  className={`btn-sm`}
                                                  title={t('Download')}
                                                >
                                                  <span className={`fa fa-download mr-1`} />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                  <DropdownItem key="en" onClick={() =>onClickHandler(i.id, 'download', 'en')}>
                                                    <Trans>English</Trans>
                                                  </DropdownItem>
                                                  {availableLangs?.map(lang => (
                                                    languageNameMapping[lang] !== undefined && languageNameMapping[lang] !== "" && (
                                                      <DropdownItem key={lang} onClick={() => onClickHandler(i.id, 'download', lang)}>
                                                        <Trans>{languageNameMapping[lang]}</Trans>
                                                      </DropdownItem>
                                                    )
                                                  ))}
                                                </DropdownMenu>
                                              </UncontrolledDropdown>
                                            


                                          </div>
                                        </td>
                                      </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </CardBody>: <div className="text-center" style={{gap:10}}><CardBody><CardTitle tag="h5"><Trans>No Invoices Found</Trans></CardTitle></CardBody></div>}
                            </Card>
                          </Col>
                        </Row>
                      </React.Fragment>
                  </TabPane>
              </TabContent>
            </div>
          </>
          :
          <div className="text-center" style={{fontSize: "1.3em"}}>
            <p>
              <Trans>Please <ColouredLink onClick={() => linkClick("/new")}>Create</ColouredLink> Or <ColouredLink onClick={() => linkClick("")}>Select</ColouredLink> an Organisation to review your plan</Trans>
            </p>
            <div style={{fontSize: "0.7em"}} className="form-text text-muted small">
              <span><Trans>You can create a new organisation or select if you have any and once subscribed, you will be able to connect to Xero.</Trans></span>
            </div>
          </div>
          }

        {/* Pay Confirmation Modal */}
        <Modal isOpen={showPayModal} toggle={handleModalClose}>
          <ModalHeader toggle={handleModalClose}>
            <Trans>Confirm Payment</Trans>
          </ModalHeader>
          <ModalBody>
            <Trans>Are you sure you want to proceed with the payment for this invoice?</Trans>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleModalClose}>
              <Trans>Cancel</Trans>
            </Button>
            <Button color="primary" onClick={handleConfirmPay}>
              <Trans>Confirm Payment</Trans>
            </Button>
          </ModalFooter>
        </Modal>

        {/* Cancel Confirmation Modal */}
        <Modal isOpen={showCancelModal} toggle={handleModalClose}>
          <ModalHeader toggle={handleModalClose}>
            <Trans>Confirm Cancellation</Trans>
          </ModalHeader>
          <ModalBody>
            <Trans>Are you sure you want to cancel this invoice? This action cannot be undone.</Trans>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={handleModalClose}>
              <Trans>No, Keep Invoice</Trans>
            </Button>
            <Button color="danger" onClick={handleConfirmCancel}>
              <Trans>Yes, Cancel Invoice</Trans>
            </Button>
          </ModalFooter>
        </Modal>

      </Page>
  );
};

const enhance = compose(
 
);

export default enhance(Details);
